import React, { createContext, useContext, useState, useEffect } from "react";
import translations from "./translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    // Получаем язык из localStorage или по умолчанию 'ru'
    const [language, setLanguage] = useState(() => {
        return localStorage.getItem("oqsaroy_lang") || "ru";
    });

    // Сохраняем язык при его изменении
    useEffect(() => {
        localStorage.setItem("oqsaroy_lang", language);
    }, [language]);

    // Функция перевода
    const t = (key) => {
        if (!translations[key]) {
            console.warn(`Translation key not found: ${key}`);
            return key;
        }
        return translations[key][language] || translations[key]["ru"] || key;
    };

    return (
        <LanguageContext.Provider value={{ language, setLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useTranslation = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error("useTranslation must be used within a LanguageProvider");
    }
    return context;
};
